import type { FC } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BiData, EndDiscountClickBiEvent } from '@wix/da-bi/pkg/events';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { PapiSellerDiscount } from '@wix/da-papi-types';
import { useEndDiscount } from '../../SellerDiscountModal/hooks';

interface Props {
  discount: PapiSellerDiscount;
}

const EndDiscountButton: FC<Props> = ({ discount }) => {
  const { t } = useTranslation();
  const { isBusy, endDiscount } = useEndDiscount();

  const onClick = useCallback(() => {
    endDiscount(discount.discountId);
  }, [discount, endDiscount]);

  return (
    <GhostButton
      size="medium"
      variant="main"
      onClick={onClick}
      disabled={isBusy}
      biData={BiData<EndDiscountClickBiEvent>({
        evid: 453,
        campaignid: discount.discountId,
      })}
    >
      {t('studio.discountRow.endDiscount')}
    </GhostButton>
  );
};
EndDiscountButton.displayName = 'EndDiscountButton';

export default EndDiscountButton;
